export default {
  zone: null,
  zones: null,
  defaultZones: {
    Perú: {
      Lima: [
        "Ancon",
        "Ate",
        "Barranco",
        "Breña",
        "Callao",
        "Carabayllo",
        "Chaclacayo",
        "Chorrillos",
        "Cieneguilla",
        "Comas",
        "El Agustino",
        "Independencia",
        "Jesus Maria",
        "La Molina",
        "La Victoria",
        "Lima",
        "Lince",
        "Los Olivos",
        "Lurigancho",
        "Lurin",
        "Magdalena del Mar",
        "Miraflores",
        "Pachacamac",
        "Pucusana",
        "Pueblo Libre",
        "Puente Piedra",
        "Punta Hermosa",
        "Punta Negra",
        "Rimac (solo urb. piedra liza)",
        "rimac (excepto urb. pied. liza)",
        "San Bartolo",
        "san borja",
        "San Isidro",
        "San Juan de Lurigancho",
        "San Juan de Miraflores",
        "San Luis",
        "San Martin de Porres",
        "San Miguel",
        "Santa Anita",
        "Santa Maria del Mar",
        "Santa Rosa",
        "Santiago de Surco",
        "Surquillo",
        "Ventanilla",
        "Villa el Salvador",
        "Villa Maria del Triunfo",
      ],
      "La Libertad": ["Trujillo"],
      "Ayacucho-Huamanga": [
        "Acocro",
        "Acos vinchos",
        "Andres avelino caceres dorregaray",
        "Ayacucho",
        "Carmen alto",
        "Chiara",
        "Jesus nazareno",
        "Ocros",
        "Pacaycasa",
        "Quinua",
        "San jose de ticllas",
        "San juan bautista",
        "Santiago de pischa",
        "Socos",
        "Tambillo",
        "Vinchos",
      ],
      Arequipa: ["Cercado", "Umacollo", "Yanahuara", "Cayma", "Cerro Colorado"],
      "Ucayali-Pucallpa": ["Calleria", "Manantay", "Yarinacocha"],
      "Loreto-Iquitos": ["Tarapoto", "Banda de Shilcayo", "Morales"],
      "Cusco-Cusco": ["Cusco", "San Jerónimo", "San Sebastián", "Santiago", "Wanchaq"],
      "Piura-Piura": ["Piura", "26 de Octubre", "Castilla"],
      "Amazonas-Jaén": ["Bagua"],
      "Junín-Huancayo": ["Tambo"],
    },
    Argentina: {
      "Buenos Aires": [
        "Villa Lugano",
        "Villa Riachuelo",
        "Mataderos",
        "Liniers",
        "Versalles",
        "Villa Real",
        "Villa Devoto",
        "Monte Castro",
        "Villa Luro",
        "Vélez Sarsfield",
        "Parque Avellaneda",
        "Villa Soldati",
        "Flores",
        "Floresta",
        "Villa Santa Rita",
        "Villa del Parque",
        "Villa Pueyrredón",
        "Agronomía",
        "Villa Grl. Mitre",
        "Nueva Pompeya",
        "Parque Chacabuco",
        "Caballito",
        "La Paternal",
        "Parque Chas",
        "Villa Urquiza",
        "Saavedra",
        "Coghlan",
        "Núñez",
        "Belgrano",
        "Colegiales",
        "Villa Ortúzar",
        "Palermo",
        "Chacarita",
        "Villa Crespo",
        "Recoleta",
        "Retiro",
        "Almagro",
        "Balvanera",
        "San Nicolás",
        "Puerto Madero",
        "Montserrat",
        "San Cristobal",
        "Boedo",
        "San Telmo",
        "Constitución",
        "Parque Patricio",
        "Barracas",
        "La Boca",
      ],
    },
    Bolivia: {
      "La Paz": [
        "Gilberto Villarroel",
        "Pacajes",
        "Juan Manuel Pando",
        "Aroma",
        "Loayza",
        "Igavi",
        "Inquisivi",
        "Murillo",
        "Los Andes",
        "Sud Yungas",
        "Nor Yungas",
        "Omasuyos",
        "Caranavi",
        "Larecaja",
        "Muñecas",
        "Camacho",
        "Bautista Saavedra",
        "Franz Tamayo",
        "Abel Iturralde",
      ],
    },
    Chile: {
      Santiago: [
        "Pirque",
        "San José de Maipo",
        "San Bernardp",
        "Puente Alto",
        "La Pintana",
        "El Bosque",
        "La Florida",
        "La Granja",
        "San Ramón",
        "La Cisterna",
        "Padre Urtado",
        "Maipú",
        "Lo Espejo",
        "Cerrillos",
        "PAC",
        "Estación Central",
        "Lo Prado",
        "Quinta Normal",
        "Cerro Navia",
        "Pudahuel",
        "San Miguel",
        "San Joaquín",
        "Macul",
        "Ñuñoa",
        "Santiago",
        "Providencia",
        "Peñalolén",
        "La Reina",
        "Las Condes",
        "Vitacura",
        "La Barnechea",
        "Independencia",
        "Recoleta",
        "Conchali",
        "Renca",
        "Huechuraba",
        "Quilicura",
      ],
    },
    Colombia: {
      Bogotá: [
        "Usaquén",
        "Suba",
        "Chapinero",
        "Barrios Unidos",
        "Engativá",
        "Teusaquillo",
        "Fontibón",
        "Candelaria",
        "Santa Fé",
        "Mártires",
        "Puente Aranda",
        "Antonio Nariño",
        "Kennedy",
        "Bosa",
        "San Cristóbal",
        "Rafael Uribe",
        "Tunjuelito",
        "Ciudad Bolivar",
        "Usme",
        "Sumapaz",
      ],
    },
    "Costa Rica": {
      "San José": [
        "Vazquez de Coronado",
        "Goicoechea",
        "Moravia",
        "Montes de Oca",
        "Tibas",
        "Curridabat",
        "San José",
        "Alajuelita",
        "Escazu",
        "Santa Ana",
        "Desamparados",
        "Turrubares",
        "Mora",
        "Furiscal",
        "Acosta",
        "Aserri",
        "León Cortes",
        "Tarrazu",
        "Dota",
        "Perez Zeledon",
      ],
    },
    Ecuador: {
      Quito: [
        "Pintag",
        "Pifo",
        "Amaguaña",
        "Alangasi",
        "La Merced",
        "Conocoto",
        "Guangopolo",
        "Tumbaco",
        "Yaruqui",
        "Checa",
        "Cumbayá",
        "Lloa",
        "Quito",
        "Nayón",
        "Puembo",
        "Zámbiza",
        "Llano Chico",
        "Tababela",
        "El Quinche",
        "Calderón",
        "Guayllabamba",
        "Pomasqui",
        "Nono",
        "San Antonio",
        "Calacalí",
        "Nanegalito",
        "Gualea",
        "Pacto",
        "Nanegal",
        "San José de Minas",
        "Atahualpa",
        "Puellaro",
        "Perucho",
        "Chavezpamba",
      ],
    },
    México: {
      "Ciudad de México": [
        "Azcapotzalco",
        "Gustavo A. Madero",
        "Miguel Hidalgo",
        "Cuauhtémoc",
        "Venustiano Carranza",
        "Benito Juarez",
        "Iztacalco",
        "Cuajimalpa",
        "Álvaro Obregón",
        "Coyoacán",
        "Iztapalapa",
        "La Magdalena Contreras",
        "Tiahuac",
        "Xochimilco",
        "Tlalpan",
        "Milpa Alta",
      ],
    },
    "República Dominicana": {
      "Santo Domingo": [
        "Pedro Brand",
        "Los Alcarrizos",
        "Santo Domingo Oeste",
        "Santo Domingo Norte",
        "Distrito Nacional",
        "Santo Domingo Este",
        "Guerra",
        "Boca Chica",
      ],
    },
    Panamá: {
      Panamá: ["Panamá", "San Miguelito", "Taboga", "Chepo", "Chimán", "Balboa"],
    },
    Paraguay: {
      Asunción: ["Zeballos Cué", "Santísima Trinidad", "San Roque", "La Recoleta", "La Rencarnación", "Catedral"],
    },
    Uruguay: {
      Montevideo: [
        "Municipio A",
        "Municipio B",
        "Municipio C",
        "Municipio Ch",
        "Municipio D",
        "Municipio E",
        "Municipio F",
        "Municipio G",
      ],
    },
    Venezuela: {
      Caracas: [
        "El Junquito",
        "Antimano",
        "Macarao",
        "Caricuao",
        "Sucre",
        "El Paraiso",
        "La Vega",
        "Coche",
        "La Pastora",
        "23 de Enero",
        "San Juan",
        "Santa Rosalía",
        "El Valle",
        "San Agustin",
        "San Pedro",
        "San Bernardino",
        "El Recreo",
        "Alta Gracia",
        "San José",
        "La Candelaria",
        "Catedral",
        "Santa Teresa",
        "Chacao",
        "Nuestra Señora del Rosario de Baruta",
        "Las Minas de Baruta",
        "El Cafetal",
        "Leoncio Martínez",
        "Petare",
        "Caucagüita",
        "La Dolorita",
        "Filas de Mariche",
        "El Haltillo",
      ],
    },
    España: {
      Madrid: [
        "Madrid",
        "Móstoles",
        "Alcalá de Henares",
        "Leganés",
        "Parla",
        "Aranjuez",
        "Getafe",
        "Las Rozas de Madrid",
      ],
      Barcelona: [
        "Barcelona",
        "L'Hospitalet de Llobregat	",
        "Badalona",
        "Sabadell",
        "Mataró",
        "Rubí",
        "Cornellá de Llobregat",
      ],
    },
  },
  countryPhoneFormat: {
    Argentina: {
      code: "54",
      length: 10,
    },
    Bolivia: {
      code: "591",
      length: 8,
    },
    Chile: {
      code: "56",
      length: 9,
    },
    Colombia: {
      code: "57",
      length: 10,
    },
    "Costa Rica": {
      code: "506",
      length: 8,
    },
    Ecuador: {
      code: "593",
      length: 10,
    },
    España: {
      code: "34",
      length: 9,
    },
    México: {
      code: "52",
      length: 10,
    },
    "República Dominicana": {
      code: "1",
      length: 10,
    },
    Panamá: {
      code: "507",
      length: 8,
    },
    Paraguay: {
      code: "595",
      length: 10,
    },
    Perú: {
      code: "51",
      length: 9,
      mask: "### ### ###",
    },
    Uruguay: {
      code: "598",
      length: 9,
      mask: "### ### ###",
    },
    Venezuela: {
      code: "58",
      length: 11,
      mask: "#### #######",
    },
  },
  countries: [
    "Argentina",
    "Bolivia",
    "Brasil",
    "Canadá",
    "Chile",
    "China",
    "Colombia",
    "Costa Rica",
    "Cuba",
    "Ecuador",
    "El Salvador",
    "España",
    "Estados Unidos",
    "Francia",
    "Granada",
    "Guatemala",
    "Guayana Francesa",
    "Haití",
    "Honduras",
    "Italia",
    "Jamaica",
    "Japón",
    "México",
    "Nicaragua",
    "Panamá",
    "Paraguay",
    "Perú",
    "Portugal",
    "Puerto Rico",
    "Reino Unido",
    "República Dominicana",
    "Suecia",
    "Suiza",
    "Trinidad y Tobago",
    "Uruguay",
    "Venezuela",
    "Costa Rica Dolar",
  ],
};
